import * as React from 'react'
import { FC } from 'react'
import Markdown from 'components/markdown'
import * as classnames from 'classnames'
import styles from './article_markdown.module.scss'

type Props = {
  className?: string | null
  content: string | null
}

const cx = classnames.bind(styles)

const ArticleMarkdown: FC<Props> = ({ className, content }) => (
  <Markdown className={cx(className, styles.markdown)} content={content} />
)

export default ArticleMarkdown
